export default __webpack_public_path__ + "static/media/hand-with-chocolate@3x.721d0e57.png";